import { connect } from 'react-redux';
import { PricingComponent } from './PricingComponent'

const mapStateToProps = (state: any): any => {
	return {
	}
}

const mapDispatchToProps: any = {
}

export const PricingContainer : any = connect(mapStateToProps, mapDispatchToProps)(PricingComponent)
